export const DOMAIN =
  "http://contestarena27.s3-website.ap-south-1.amazonaws.com";
export const REDIRECT_URI =
  "http://contestarena27.s3-website.ap-south-1.amazonaws.com/callback";
